import { Button } from '@/components/ui/button';
import { Zap, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuizCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 px-4 bg-muted">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-semibold mb-6">
          <Zap className="w-4 h-4" /> Free 60-Second Quiz
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
          What's Your Content System Score?
        </h2>
        <p className="text-muted-foreground text-lg max-w-2xl mx-auto mb-8">
          Find out what's slowing your content growth. Get your personalized score, biggest bottlenecks, and a custom roadmap — in under 60 seconds.
        </p>
        <Button
          variant="hero"
          size="xl"
          onClick={() => navigate('/quiz')}
        >
          Take the Quiz <ArrowRight className="w-5 h-5 ml-1" />
        </Button>
      </div>
    </section>
  );
};

export default QuizCTA;
